import { createStrictContext, useStrictContext } from '../../lib/react';

import { INotificationContext } from './types';

export const notificationContext = createStrictContext<INotificationContext>();

export function useNotifications() {
  return useStrictContext(notificationContext);
}
